import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-434c2b19"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "addAffiliation",
  tabindex: "-1",
  "aria-labelledby": "addAffiliation",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title text-center fw-bold w-100",
  id: "addAffiliation"
}
const _hoisted_6 = { class: "modal-body py-4" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_9 = { class: "row mx-0 px-0 py-4 d-flex justify-content-center flex-sm-row flex-column-reverse" }
const _hoisted_10 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_11 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center my-4 my-lg-0" }
const _hoisted_12 = {
  class: "modal fade",
  id: "confirmModalAddAffiliation",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_13 = { class: "modal-dialog" }
const _hoisted_14 = { class: "modal-content" }
const _hoisted_15 = { class: "modal-header" }
const _hoisted_16 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_18 = { class: "modal-body p-0" }
const _hoisted_19 = { class: "row justify-content-between py-4 mb-4 border-bottom content-area" }
const _hoisted_20 = { class: "col-4 text-center" }
const _hoisted_21 = { class: "col-8" }
const _hoisted_22 = { class: "row mx-0 px-0 mb-4 d-flex justify-content-center flex-lg-row flex-column-reverse" }
const _hoisted_23 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_24 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }

import { computed, ref, PropType, onMounted } from 'vue'
import { useStore } from 'vuex'
import { maxLength, minLength, required } from '@vuelidate/validators'
import { customMaxLength } from '@/utils'
import useVuelidate from '@vuelidate/core'
import { useRouter } from 'vue-router'

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import communityPortfoliosServices from '@/services/communities-portfolios.service'

import { MAX_WORD, DEFAULT_MIN_LENGTH } from '@/constants/number'
import { COMMUNITY_PORTFOLIOS_STORE } from '@/store/constants'
import { REGEX_EMOJI } from '@/constants/regex'
import commonService from '@/services/common.service'
import { debounce } from 'lodash'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  createDepartmentError: Function as PropType<() => void | undefined>,
},
  emits: ['toogleModalAddWork'],
  setup(__props, { expose, emit }) {

const props = __props

const store = useStore()
const router = useRouter()

const modalAddAffiliation = ref()
const modalAddAffiliationConfirm = ref()
const isShowModalConfirm = ref(false)
onMounted(() => {
  const modalAddAffiliationElement = document.getElementById('addAffiliation')
  modalAddAffiliation.value = new Modal(modalAddAffiliationElement)
  modalAddAffiliationConfirm.value = new Modal(document.getElementById('confirmModalAddAffiliation'))
  modalAddAffiliationElement?.addEventListener('hidden.bs.modal', function () {
    if (isShowModalConfirm.value) return
    onReset()
  })
})
const onReset = (): void => {
  v$.value.$reset()
  ngKeyContent.value = false
  formData.value = {
    content: '',
  }
}



expose({
  onReset,
})

const rules = computed(() => {
  return {
    content: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, MAX_WORD),
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
  }
})


const formData = ref({
  content: '',
})
const submittingButton = ref<boolean>(false)

const v$ = useVuelidate(rules, formData)

const showModalConfirm = async (): Promise<void> => {
  // 2022/09/14 TienNV Fix double click button
  submittingButton.value = true
  v$.value.$touch()

  isCheckedNGContent.value = false
  await checkNGContent()
  while (!isCheckedNGContent.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (v$.value.$invalid || ngKeyContent.value) {
    submittingButton.value = false
    return
  }

  modalAddAffiliation.value?.hide()
  toogleModalAddAffiliationConfirm('show')
  submittingButton.value = false
}

const toogleModalAddAffiliationConfirm = (method: 'show' | 'hide') => {
  modalAddAffiliationConfirm.value?.[method]()
  isShowModalConfirm.value = method === 'show'
}

const onSubmit = async () => {
  submittingButton.value = true

  try {
    const response = await communityPortfoliosServices.createPortfoliosDepartment({
      id: router.currentRoute.value.params.id,
      name: formData.value.content,
    })

    if (response.status === 200) {
      localStorage.removeItem('checkConfirm')
      await props.createDepartmentError('')
      await store.dispatch(COMMUNITY_PORTFOLIOS_STORE.ACTIONS.CREATE_DEPARTMENT, { id: response.data.data.portfolio_work_history_corporation_id, name: formData.value.content })
    } else if (response?.response?.status === 400) {
      await props.createDepartmentError(response?.response?.data?.data[0]?.message_code)
    } else {
      await props.createDepartmentError('ERROR_CREATE')
    }
    await onReset()
    toogleModalAddAffiliationConfirm('hide')
    emit('toogleModalAddWork', 'show')
  } catch (error: any) {
    console.log('err', error?.response)
    await props.createDepartmentError('ERROR_CREATE')
    await onReset()
    toogleModalAddAffiliationConfirm('hide')
    emit('toogleModalAddWork', 'show')
  } finally {
    submittingButton.value = false
  }
}

const isCheckedNGContent = { value: false }
const ngKeyContent = ref<boolean>(false)
const checkNGContent = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.content.$model })
  ngKeyContent.value = data.data?.data?.has_ngword
  isCheckedNGContent.value = true
}, 100)

const backToAffiliation = () => {
  modalAddAffiliationConfirm.value.hide()
  modalAddAffiliation.value.show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('SG441modalTitleAdd')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-target": '#addWorkModal',
              "data-bs-toggle": 'modal',
              "aria-label": "Close",
              onClick: onReset
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "content",
                class: _normalizeClass(['form-control', ngKeyContent.value || _unref(v$).content.$error ? 'is-invalid' : '']),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                placeholder: _unref(translate)('companyName'),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGContent) && _unref(checkNGContent)(...args)))
              }, null, 42, _hoisted_7), [
                [
                  _vModelText,
                  _unref(v$).content.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              (ngKeyContent.value && !_unref(v$).content.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                : _createCommentVNode("", true),
              _createVNode(InputErrorMessage, {
                title: _unref(translate)('affiliation'),
                params: [1, 100],
                validator: _unref(v$).content.$errors[0]?.$validator
              }, null, 8, ["title", "validator"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(Button, {
                  title: _unref(translate)('cancel'),
                  className: 'me-lg-2',
                  type: 'secondary',
                  "data-bs-target": '#addWorkModal',
                  "data-bs-toggle": 'modal',
                  onClick: onReset
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(Button, {
                  title: _unref(translate)('add'),
                  type: 'secondary',
                  loading: submittingButton.value,
                  disabled: submittingButton.value,
                  onClick: _withModifiers(showModalConfirm, ["prevent"])
                }, null, 8, ["title", "loading", "disabled", "onClick"])
              ])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h5", _hoisted_16, _toDisplayString(_unref(translate)('SG441modalTitleAdd')), 1),
            _hoisted_17
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(translate)('affiliation')), 1),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(v$).content.$model), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(Button, {
                    onClick: backToAffiliation,
                    title: _unref(translate)('back'),
                    type: 'secondary'
                  }, null, 8, ["title"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(Button, {
                    class: "button-submit",
                    title: _unref(translate)('add'),
                    loading: submittingButton.value,
                    disabled: submittingButton.value,
                    type: 'secondary',
                    onClick: onSubmit
                  }, null, 8, ["title", "loading", "disabled"])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})